import RelatedPhotosRendererSuspense from '../src/RelatedPhotos/RelatedPhotosRendererSuspense';
export default RelatedPhotosRendererSuspense;
